const LOGOS = {
  facebook:
    "https://srv-cdn.onedio.com/store/475e330d4a1c16685140136774d717bc08b87234ba77d7ef8270ca9a4cca1dde.png",
  instagram:
    "https://srv-cdn.onedio.com/store/d615703dcc1d789b2eef6ce98d9caf875237cd8c1eb463c74431aa8acf52e97c.png",
  youtube:
    "https://srv-cdn.onedio.com/store/ac62e6e999731c80cfebb0f13f45989612e1f5f73dcbb9102da0146710404eb0.png",
  whatsapp:
    "https://srv-cdn.onedio.com/store/481e6ca93817abb7bcb691dc9d001b4ae70fb6d74a7816c367d64de9551f5c43.png",
  x:
    "https://srv-cdn.onedio.com/store/92478870665df6cdb7948d73b868808baec3629bfc54a12c75188a03958f14ab.png",
  tiktok:
    "https://srv-cdn.onedio.com/store/766d252ce630ed3a740ea3833f5118b6340a5f6fd9281e93f2d37bb84cac3efb.png",
  pinterest:
    "https://srv-cdn.onedio.com/store/333c0f1ad1422de851eee8673478269a451d582a7ac5d293eb4a4e7fad06f8e6.png",
  linkedin:
    "https://srv-cdn.onedio.com/store/347399f0d3fdf0ff97fea0948ec5e74d9163d6faa0fa1a8dc6c4b6edf1d74017.png",
};

export const PLATFORM_SHADOWS = {
  facebook: "51,127,255",
  instagram: "126,65,215",
  youtube: "255,0,0",
  whatsapp: "37,211,102",
  x: "0,0,0",
  tiktok: "0,0,0",
  pinterest: "230,29,39",
  linkedin: "11,102,194",
};

export function getPlatformShadow(rgb) {
  return [
    `0px 73.721px 58.977px 0px rgba(${rgb}, 0.06)`,
    `0px 30.799px 24.639px 0px rgba(${rgb}, 0.08)`,
    `0px 16.466px 13.173px 0px rgba(${rgb}, 0.07)`,
    `0px 9.231px 7.385px 0px rgba(${rgb}, 0.06)`,
    `0px 4.902px 3.922px 0px rgba(${rgb}, 0.04)`,
    `0px 2.04px 1.632px 0px rgba(${rgb}, 0.03)`,
  ].join(", ");
}

export const socialMediaSlides = [
  {
    id: 1,
    title: "Facebook",
    titleEN: "Facebook",
    platform: "facebook",
    logo: LOGOS.facebook,
    items: [
      {
        name: "Onedio Facebook",
        nameEN: "Onedio Facebook",
        count: "2.9M",
      },
      {
        name: "GoyGoy Facebook",
        nameEN: "GoyGoy Facebook",
        count: "370K",
      },
      {
        name: "Yemek Facebook",
        nameEN: "Yemek Facebook",
        count: "900K",
      },
      {
        name: "Video Facebook",
        nameEN: "Video Facebook",
        count: "230K",
      },
      {
        name: "IQ Facebook",
        nameEN: "IQ Facebook",
        count: "370K",
      },
    ],
  },
  {
    id: 2,
    title: "Instagram",
    titleEN: "Instagram",
    platform: "instagram",
    logo: LOGOS.instagram,
    items: [
      {
        name: "Onedio Instagram",
        nameEN: "Onedio Instagram",
        count: "2.9M",
      },
      {
        name: "IQ Instagram",
        nameEN: "IQ Instagram",
        count: "160K",
      },
      {
        name: "Yemek Instagram",
        nameEN: "Yemek Instagram",
        count: "570K",
      },
      {
        name: "Video Instagram",
        nameEN: "Video Instagram",
        count: "74K",
      },
      {
        name: "GoyGoy Instagram",
        nameEN: "GoyGoy Instagram",
        count: "340K",
      },
    ],
  },
  {
    id: 3,
    title: "Others",
    titleEN: "Others",
    items: [
      {
        name: "Onedio YouTube",
        nameEN: "Onedio YouTube",
        count: "4.1M",
        logo: LOGOS.youtube,
        platform: "youtube",
      },
      {
        name: "WhatsApp",
        nameEN: "WhatsApp",
        count: "300K",
        logo: LOGOS.whatsapp,
        platform: "whatsapp",
      },
      {
        name: "Onedio X",
        nameEN: "Onedio X",
        count: "1M",
        logo: LOGOS.x,
        platform: "x",
      },
      {
        name: "Onedio TikTok",
        nameEN: "Onedio TikTok",
        count: "244K",
        logo: LOGOS.tiktok,
        platform: "tiktok",
      },
      {
        name: "Pinterest",
        nameEN: "Pinterest",
        count: "580K",
        logo: LOGOS.pinterest,
        platform: "pinterest",
      },
      {
        name: "LinkedIn",
        nameEN: "LinkedIn",
        count: "105K",
        logo: LOGOS.linkedin,
        platform: "linkedin",
      },
    ],
  },
];
